export const ABSMARTLY_APPLICATION_NAME = 'nerdwallet-wealth-partners'

export const AB_EXPERIMENT_COOKIE_NAME = 'ab_experiment_decision'

export enum StaticExperimentVariants {
  Control = 'control',
  Treatment = 'treatment',
}

export enum StaticExperimentMultiVariants {
  Control = 'control',
  Treatment1 = 'treatment1',
  Treatment2 = 'treatment2',
}

export enum StaticDeviceTypeVariants {
  Mobile = 'mobile',
  Desktop = 'desktop',
}
